import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { engineeringService, EngineeringData } from '@/services/engineering-service'
import { toast } from 'sonner'

export function useEngineering() {
    const queryClient = useQueryClient()

    const engineeringQuery = useQuery({
        queryKey: ['engineering-page'],
        queryFn: () => engineeringService.getEngineering(),
    })

    const updateEngineeringMutation = useMutation({
        mutationFn: (data: Partial<EngineeringData>) =>
            engineeringService.updateEngineering(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['engineering-page'] })
            toast.success('Mühendislik sayfası güncellendi')
        },
        onError: (error: any) => {
            console.error('API Error:', error)
            toast.error('Güncelleme sırasında bir hata oluştu')
        },
    })

    return {
        engineering: engineeringQuery.data,
        isLoading: engineeringQuery.isLoading,
        isError: engineeringQuery.isError,
        updateEngineering: updateEngineeringMutation.mutateAsync,
        isUpdating: updateEngineeringMutation.isPending
    }
}
